import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { BroadworksSSOConfigDTO } from '../../../NonReact/Types/Types'
import { getBroadworksSSOConfig } from '../API/GenericConfigAPI'
import { ReactState } from '../Types/Types'
import { $error } from '../Utils/ConsoleUtils'
import { useFeatureFlag } from './useFeatureFlag'

export const useBroadworksSSOConfig = (): Nullable<BroadworksSSOConfigDTO> => {
    const isBroadworksSSOEnabled: Definable<boolean> = useFeatureFlag('enableBroadworksSelfSignUp')
    const [broadworksSSOConfig, setBroadworksSSOConfig]: ReactState<Nullable<BroadworksSSOConfigDTO>> =
        useState<Nullable<BroadworksSSOConfigDTO>>(null)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        if (isBroadworksSSOEnabled) {
            getBroadworksSSOConfig()
                .then((ssoConfig: Nullable<BroadworksSSOConfigDTO>): void => {
                    if (isMounted.current) {
                        setBroadworksSSOConfig(ssoConfig)
                    }
                })
                .catch((): void => {
                    if (isMounted.current) {
                        $error('Failed to get Broadworks SSO config')
                    }
                })
        }
    }, [isBroadworksSSOEnabled])

    return broadworksSSOConfig
}
